import { useEffect } from 'react';

// Run `fn` now and every `ms` while the tab is visible. A hidden tab (another
// tab in front, window minimised) stops polling; coming back refreshes once
// straight away and restarts the timer. Keeps a manager screen left open all
// day from hitting the database around the clock.
export function useVisiblePolling(fn, ms) {
  useEffect(() => {
    let timer = null;
    const start = () => { if (!timer) timer = setInterval(fn, ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    const onVisibility = () => {
      if (document.hidden) { stop(); } else { fn(); start(); }
    };
    fn();
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [fn, ms]);
}
